export const SET_WEBSITE_SLUG = 'websiteContext/SET_WEBSITE_SLUG';
export const RESET_WEBSITE_SLUG = 'websiteContext/RESET_WEBSITE_SLUG';

